export const leadForm: object = {
  leadForm: {
    options: {
      receiveMarketingCommunications: 'Yes, I would like to receive marketing communications from SAP',
      createAccountAndSaveDetails: 'Create Account and save my details',
      alreadyHaveAnAccount: 'Already have an account?',
      loggedInAs: 'Logged in as',
      logIn: 'Log In',
      logOut: 'Log Out',
      employeeUserLogIn1: 'Hi colleague, please',
      employeeUserLogIn2: 'log in',
      employeeUserLogIn3: 'to continue'
    },
    fields: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      firstNameEmployee: 'First Name (Optional)',
      lastNameEmployee: 'Last Name (Optional)',
      emailEmployee: 'Email (Optional)',
      phone: {
        phoneNumber: 'Phone Number (Optional)',
        phoneTooltip: 'Entering a phone number will make it easier for the publisher to clarify any' +
          ' open questions regarding your request directly with you'
      },
      street: {
        streetAddress: 'Street Address',
        streetAddressEmployee: 'Street Address (Optional)',
        streetTooltip: 'Entering a street address will help us better identify your company',
      },
      companyName: 'Company Name',
      country: 'Country',
      city: 'City',
      region: 'State/Region',
      postalCode: 'Postal Code',
      message: 'Message (Optional)',
      customerId: 'Company CRM ID',
      expectedTotalValue: {
        label: 'SAP Total Revenue Share Value',
        tooltipContent: 'Please enter 10,000 EUR as an average value if you do not know this yet. You can update Harmony with this information when appropriate.'
      },
      currency: 'Currency',
      expectedStartDate: 'Expected Start Date',
      expectedEndDate: 'Expected End Date',
    },
    sections: {
      companyDetails: 'Company Details',
      personalDetails: 'Personal Details',
      productIcon: 'Product Icon',
      partnerIcon: 'Partner Icon',
      yourDerails: 'Your Details',
      customerDetails: 'Customer Details',
      contractDetails: 'Contract Details',
    },
    success: {
      formSubmitted: 'Your message was submitted',
      nextAction: 'will get back to you within the next two business days.',
      freeTrialIsReady: 'Thank you! Your free trial is ready.',
      getTrialNextAction: 'Click below to be taken to the trial access page.',
      getTrial: 'Get Trial',
    },
    errors: {
      invalidEmail: 'The email address you entered is not valid.',
      required: 'This field is mandatory.',
      tooLong: 'This text is too long.',
      internalServerError: 'An internal error occurred. Please try again later or',
      contactSupport: 'contact support',
      employeeSAPCompany: 'Please identify a VALID end customer or prospect',
      invalidDate: 'Enter a date in the format dd-MMMM-YYYY',
      maxDate: 'Enter a date in the format dd-MMMM-YYYY',
      minDate: 'Enter a date in the format dd-MMMM-YYYY',
      startDate: 'Date must be earlier than {{minDate}}',
      endDate: 'Date must be later than {{maxDate}}',
      number: 'Please enter a numeric value with the maximum of 2 decimals.',
    },
    cta: {
      trial: 'Request Trial',
      buy: 'Contact Sales',
      rfi: 'Send Message'
    },
    userInfo: {
      name: 'Name',
      phone: 'Phone'
    },
    customerDetails: 'Please identify SAP end customer or prospect.',
    consentDescription: 'I agree that SAP will share this data with {{publisher}} so that they may contact me regarding my request.',
    privacyStatement: 'View our Privacy Statement.'
  }
};
